<div class="activate-transports-dialog">

  <div class="dialog-layout">

    <sc-dialog-title class="dialog-h2">
      <sc-dictionary-label
        dictionaryKey="tmc-yard.entity.activate-transports-dialog.dialog.title"></sc-dictionary-label>
    </sc-dialog-title>


    <div class="dialog-content no-field-space">

      <sc-flex vertical fitHeight stretchContent>
        <mat-radio-group [(ngModel)]="selectedType" (change)="selectedTypeChanged($event)">
          <sc-flex [gap]="16">


            <mat-radio-button value="{{queryType.NOT_RELEVANT}}">
              <sc-dictionary-label
                dictionaryKey="tmc-yard.entity.activate-transports-dialog.option.not-relevant"></sc-dictionary-label>
            </mat-radio-button>
            <mat-radio-button class="margin-left" value="{{queryType.DELETED}}">
              <sc-dictionary-label
                dictionaryKey="tmc-yard.entity.activate-transports-dialog.option.deleted"></sc-dictionary-label>
            </mat-radio-button>

            <mat-form-field class="search-field margin-left" appearance="fill">
              <mat-label>
                <sc-dictionary-label
                  dictionaryKey="tmc-yard.entity.activate-transports-dialog.query"></sc-dictionary-label>
              </mat-label>
              <input matInput [(ngModel)]="data.query" [ngModelOptions]="{standalone: true}">
            </mat-form-field>


            <sc-button class="margin-left" (click)="performSearch()"
              dictionaryKey="tmc-yard.entity.activate-transports-dialog.query"></sc-button>

          </sc-flex>
        </mat-radio-group>

        <sc-content-spacer vertical></sc-content-spacer>

        <div class="table-container">


          <table mat-table class="mat-table-selection" [dataSource]="dataSource">

            <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
            <ng-container matColumnDef="noRecord">
              <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
                <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
              </td>
            </ng-container>

            <ng-container matColumnDef="selection">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let transport">
                <mat-checkbox disabled="true" [(ngModel)]="transport.selected"></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="planningDate">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label
                  dictionaryKey="tmc-yard.entity.transport.masterdata.planningDate"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.planningDate}} </td>
            </ng-container>

            <ng-container matColumnDef="carrier">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.carrier"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.carrier}} </td>
            </ng-container>

            <ng-container matColumnDef="identifier">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label
                  dictionaryKey="tmc-yard.entity.transport.masterdata.numberPlate"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.identifier}} </td>
            </ng-container>

            <ng-container matColumnDef="string2">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.string2"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.string2}} </td>
            </ng-container>

            <ng-container matColumnDef="registrationCode">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label
                  dictionaryKey="tmc-yard.entity.transport.masterdata.registrationCode"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let transport"> {{transport.registrationCode}} </td>
            </ng-container>

            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.options"></sc-dictionary-label>
              </th>
              <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"> {{transport.options}}
              </td>
            </ng-container>

            <ng-container matColumnDef="cargo">
              <th mat-header-cell *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.cargo"></sc-dictionary-label>
              </th>
              <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"> {{transport.cargo}}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

            <tr mat-row *matRowDef="let transport; columns: columnsToDisplay" [attr.data-transport-id]="transport.id"
              [ngClass]="{'selected': transport.selected}" (click)="toggleSelection(transport)"></tr>

            <tr [class.hide]="!showNoData()" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
          </table>
        </div>
      </sc-flex>

    </div>


    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="closeDialog()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button primary [disabled]="!isActivateTransportsEnabled()" (click)="activateTransports()"
        [dictionaryKey]="selectedType === queryType.NOT_RELEVANT ? 'tmc-yard.entity.activate-transports-dialog.action.activate-not-relevant': 'tmc-yard.entity.activate-transports-dialog.action.activate-deleted'">
      </sc-button>
    </sc-actionbar>
  </div>
</div>
